import { Area, IArea } from '@app/models/Area'
import { AreaUnits } from '@app/models/enums'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import { Input, InputGroup, InputGroupAddon } from 'reactstrap'
import CustomInput from './CustomInput'

interface IComponentProps {
  bsSize?: 'sm' | 'lg' | undefined
  className?: string
  onChange: (newValue: Area) => void
  value: IArea
}

export default class LotSizeInput extends React.PureComponent<IComponentProps> {
  constructor(props: any) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <div className={this.props.className}>
        <InputGroup>
          <CustomInput
            type='number'
            className='form-control'
            bsSize={this.props.bsSize}
            placeholder='Enter a number'
            value={this.props.value.lotSize}
            step='0.01'
            onChange={this._onChangeLotSize}
          />
          <InputGroupAddon addonType='append'>
            <Input
              type='select'
              value={this.props.value.units}
              onChange={(e) => this._onChangeUnits(e.target.value)}
            >
              <option value='SqFt'>square feet</option>
              <option value='Acres'>acres</option>
            </Input>
          </InputGroupAddon>
        </InputGroup>
      </div>
    )
  }

  private _onChangeLotSize(newLotSize: number) {
    const newValue = (this.props.value as Area).set('lotSize', newLotSize)
    this.props.onChange(newValue as Area)
  }

  private _onChangeUnits(newUnits: string) {
    const newValue = (this.props.value as Area).set(
      'units',
      AreaUnits[newUnits as keyof typeof AreaUnits],
    )
    this.props.onChange(newValue as Area)
  }
}
